import React from 'react';
import T from 'prop-types';

import SwitchButtons from '../../../../components/SwitchButtons';

const chartTypeOptions = [
  { text: <i className="hicon-chart-view-bar" />, value: 'column' },
  { text: <i className="hicon-chart-view-line" />, value: 'spline' },
];

const ChartTypeToggle = ({ active, disabled, onChange }) => (
  <div className="chart-type-toggle">
    <SwitchButtons
      options={chartTypeOptions}
      active={active}
      size="lg"
      disabled={disabled}
      containerClassName="btn-group-square type-switcher-large"
      onChange={onChange}
    />
  </div>
);

ChartTypeToggle.propTypes = {
  active: T.string.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default ChartTypeToggle;
